export default {
  brand: 'imgify',
  domain: 'imgify.ru',
  title: 'imgify.ru — бесплатные инструменты для изображений',
  description:
    'Быстрые локальные инструменты для изображений: конвертер PNG в JPG и JPG в PNG. Без регистрации и отправки файлов на сервер.',
  metrikaId: '110073985',
  ogImage: 'https://imgify.ru/og-image.png',
}
